const BookingFooter = ({ onContinueClick, isLoading = false }) => {
  return (
    <div className="button_footer">
      <div className="ft_button_block">
        <a
          className="termsLink"
          href="terms.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          View terms &amp; conditions
        </a>
        <div className="buttonContainer">
          <button
            className="button-submit js-btn-next"
            type="button"
            title="Next"
            onClick={() => onContinueClick()}
          >
            Continue
            <div
              className="loader"
              id="loader"
              style={{
                display: isLoading ? "inline-block" : "none",
              }}
            ></div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingFooter;
